import React from "react";
import { Link, Text, Stack } from "@chakra-ui/core";
import Logo from "../elements/Logo";

const Footer = ({showLogo = false}) => {
  return (
    <Stack alignItems="center" my="12px" width="100%">
      <Text color="primary.300" textAlign="center" fontSize="xs">
        © 2020 Dotpay, Inc. All rights reserved.
      </Text>
      {
        showLogo && (
          <Link href="https://dotpay.io">
            <Logo width="60px" color="green" />
          </Link>
        )
      }
    </Stack>
  );
};

export default Footer;
